var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRjGamesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.9 42.6",
    style: {
      enableBackground: "new 0 0 68.9 42.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,22.7l1.3-0.2l-0.7-5.7L35,22.7z M11.4,21.2L9,21.6v3.4l2.4-0.4L11.4,21.2z M17.1,28.6l0-10.4l2-0.4l0,11.2 l-1.2,1.4L14.7,31l-0.4-1.9L17.1,28.6z M7,20.1l5.2-0.9l1.2,0.9v5l-1.2,1.4l1.1,4.8l-2,0.4l-1-4.8L9,27.1v5l-2,0.4L7,20.1z  M31.4,19.5l-1.9,0.3l0-2L27,18.3v8.5l2.4-0.4l0-3l-1.2,0.2v-2l3.1-0.6v5.8l-1.2,1.4l-4,0.7l-1.2-1v-10l1.2-1.3l4-0.7l1.2,0.9V19.5 z M36.9,27L36.9,27l-0.4-2.7l-1.8,0.3l-0.3,2.8l0,0l-1.9,0.3l1.4-12.6l3.5-0.6l1.4,12.1L36.9,27z M47.2,25.2l-2,0.4v-7.1l-1.8,4.4 L41.6,19l0,7.1l-1.9,0.4V14.1l1.7-0.3l2.1,4.4l2.1-5.1l1.7-0.3V25.2z M54.5,13.4l-4,0.7l0,3.2l3.2-0.6l0,2l-3.2,0.6l0,3.2l4-0.7v2 l-6,1.1V12.5l6-1.1V13.4z M61.9,14l-2,0.4l0-2l-2.5,0.4v3.2l3.2-0.6l1.2,1v4.8l-1.2,1.4l-4,0.7l-1.2-1v-2.8l2-0.4v2l2.4-0.4l0-3.2 l-3.2,0.6l-1.2-1v-4.8l1.2-1.4l4-0.7l1.2,1V14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,5.1l-20-3.6v7.3L1.7,16.9v20.5l20.5,3.7v-7.4l45-8.2V5.1z M48.5,3.1l15,2.7l-15,2.7V3.1z M20.8,39.5 L5.5,36.8L20.8,34V39.5z M65.8,24.5L3.1,35.9V18.1L65.8,6.7V24.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRjGamesLogo);
export default __webpack_public_path__ + "static/media/RJ-Games_logo.d5acf9c2ad39191394d240f4a7ebd35d.svg";
export { ForwardRef as ReactComponent };